/**
 * Builds a stable HTML id for a disclosure button's `aria-controls` target. Section keys
 * occasionally fall back to a display label, which can contain spaces or punctuation that a bare
 * id can't safely carry.
 */
export function toPanelId(prefix: string, key: string): string {
  return `${prefix}-${key.trim().replace(/[^a-zA-Z0-9_-]+/g, '-')}`;
}

/** id of the Layer Attributes picker, referenced by its trigger's `aria-controls` while it's open. */
export const METADATA_PICKER_PANEL_ID = 'layer-attributes-picker';

/** id of the Layers panel, referenced by the Layers button's `aria-controls` while it's open; onboarding also targets it. */
export const LAYERS_PANEL_ID = 'layer-picker-open';

/** id of the Geo-referenced Maps panel, referenced by its button's `aria-controls` while it's open. */
export const GEOREFERENCED_MAPS_PANEL_ID = 'georeferenced-maps-panel';
